import { render, staticRenderFns } from "./EmploymentAllowancesImportCompleted.vue?vue&type=template&id=1767977e"
import script from "./EmploymentAllowancesImportCompleted.vue?vue&type=script&lang=js"
export * from "./EmploymentAllowancesImportCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports